import { useEffect, useRef } from "react";

export function useInitializeRewardCtas(values, setFieldValue) {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!values || !setFieldValue) return;
    if (initializedRef.current) return;

    const hasCtas = values.ctaModel?.length > 0;
    const hasRewardIds = values.rewardIds?.length > 0;
    const isNew = (values.integratedRewardsClientDashboardId || 0) === 0 && (values.integratedRewardsDashboardId || 0) === 0;

    if (!values.allRewards) {
      return;
    }

    if (hasCtas && hasRewardIds) {
      return;
    }

    let modelCtas = values.ctaModel;
    if (!modelCtas || modelCtas.length === 0) {
      modelCtas = values.allRewards.map((r) => ({
        integratedRewardId: r.integratedRewardId,
        rewardName: r.rewardName,
        rewardType: r.rewardType,
        providerName: r.providerName,
        isAvailable: r.isAvailable
      }));
      setFieldValue("ctaModel", modelCtas);
    }

    if (!hasRewardIds && modelCtas.length > 0) {
      const ids = modelCtas.map((x) => x.integratedRewardId);
      setFieldValue("rewardIds", ids);
      if (isNew && (!values.originalRewardIds || values.originalRewardIds.length === 0)) {
        setFieldValue("originalRewardIds", ids);
      }
    }

    initializedRef.current = true;
  }, [values.allRewards]);
}
